import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { APICoreService } from 'src/app/common/services/api-core/api-core.service';
import {
  CoachingLogType,
  CoachingSessionTypeDTO,
} from '../../dtos/coaching-session.dto';
import { coachingSessionTypeDTOFromAPIResponse } from '../../helpers/translators/coaching-session-dto.translator';
import { CoachingSessionTypeAPIResponse } from '../../types/responses/coaching-log.responses';
import { LogTypeSearchService } from '../log-type-search/log-type-search.service';

export interface CreateSessionTypePayload {
  name: string;
  description?: string;
  layout: CoachingLogType;
  is_coaching: boolean;
  is_shared: boolean;
  district_id?: number;
}

export interface UpdateSessionTypePayload {
  name: string;
  description?: string;
  is_shared?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SessionTypeService {
  constructor(
    private apiService: APICoreService,
    private logTypeSearchService: LogTypeSearchService
  ) {}

  getSessionTypes(districtId: number): Observable<CoachingSessionTypeDTO[]> {
    return this.apiService
      .getRequest('egrowe/coachlogs/types', {
        per_page: 100,
        district_id: districtId,
      })
      .pipe(
        map((response) =>
          (response.items as CoachingSessionTypeAPIResponse[]).map((item) =>
            coachingSessionTypeDTOFromAPIResponse(item)
          )
        )
      );
  }

  createSessionType(
    payload: CreateSessionTypePayload
  ): Observable<CoachingSessionTypeDTO> {
    return this.apiService
      .postJSONRequest('egrowe/coachlogs/types', payload)
      .pipe(
        tap(() => this.logTypeSearchService.clearCache()),
        map((response) =>
          coachingSessionTypeDTOFromAPIResponse(
            response.item as CoachingSessionTypeAPIResponse
          )
        )
      );
  }

  updateSessionType(
    id: number,
    payload: UpdateSessionTypePayload
  ): Observable<CoachingSessionTypeDTO> {
    return this.apiService
      .putJSONRequest(`egrowe/coachlogs/types/${id}`, payload)
      .pipe(
        tap(() => this.logTypeSearchService.clearCache()),
        map((response) =>
          coachingSessionTypeDTOFromAPIResponse(
            response.item as CoachingSessionTypeAPIResponse
          )
        )
      );
  }

  setSessionTypeHidden(
    id: number,
    hidden: boolean,
    districtId: number
  ): Observable<boolean> {
    return this.apiService
      .putJSONRequest(`egrowe/coachlogs/types/${id}/hide`, {
        hidden,
        district_id: districtId,
      })
      .pipe(
        tap(() => this.logTypeSearchService.clearCache()),
        map((response) => Boolean(response.item.is_hidden))
      );
  }
}
